/**
 * Created by guga on 7/21/2016.
 */
 import {ItemBean} from '../item.bean';
 declare var Swal: any
 declare var $ : any;
 import { CompanyService }  from '../../services/company.service';
 import { AppDataService } from '../../services';
 import { TranslationService } from '../../services';

 export class Door extends ItemBean {

    public _companyService : CompanyService;
    public _appData : AppDataService;
    public translate: TranslationService

    constructor (){
        super();
    }
    public setCompanyService(service){
        this._companyService=service;
    }
    public setAppData(service){
        this._appData=service;
    }
    public setTranslation(service){
        this.translate=service;
    }
    public openDoor(data){
        let roomToGo=data.param.roomToGo;
        
        let hasKey=data.hasKey   
        if (roomToGo && roomToGo!=this._appData.room.id){

          this._companyService.getRoom(roomToGo.toString()).get().then(r=>{
            let room=r.data();
            let spaceSpec={columns:1,rows:1,x:200,y:200}
            if (data.param.teleport.constructor == Array){
              let id= (Math.floor(Math.random() * data.param.teleport.length))  
              this._appData.instagramUser.positionDoor={x:data.param.teleport[id].x,y:data.param.teleport[id].y,room:roomToGo}
            }    
            else{
              this._appData.instagramUser.positionDoor={x:data.param.teleport.x,y:data.param.teleport.y,room:roomToGo}
            }              
            if (room.spaceSpec){
              spaceSpec=room.spaceSpec;
            }
            let spaces=[]
            let x=this._appData.instagramUser.positionDoor.x
            let y=this._appData.instagramUser.positionDoor.y
            let totalUsers=Math.ceil(spaceSpec.x*spaceSpec.y/10);
            let id=0
            let myid=0
            for (let j=0;j<spaceSpec.rows;j++){
              for (let i=0;i<spaceSpec.columns;i++){
                if ( x>=(i*spaceSpec.x) && x<=(((i+1)*spaceSpec.x)-1) && y>=(j*spaceSpec.y) && y<=(((j+1)*spaceSpec.y)-1)){
                  myid=id;
                }
                id++
              }
            }
            this._companyService.getUserRoomPosition(roomToGo).where('sp','==',myid).get().then((snap)=>{
              let tusers=0;
              snap.forEach(userOnRoom=>{
                let us=userOnRoom.data(); //objects correspond to users;
                if (us){
                  tusers++
                }
              })
              if (!room.multiplayer){room.multiplayer=0}
              if (room.multiplayer==0){
                tusers=0
                totalUsers=10000;
              }
                if (tusers>=totalUsers){
                  Swal.fire({
                    title: this.translate.instant('DOOR_BEAN_1'),
                    text:this.translate.instant('DOOR_BEAN_3'),
                    });   
                }
                else{
                  let date=new Date();
                  let time=date.getTime();
                  let swalObj={
                    title: this.translate.instant('TRANSITION_TITLE'),
                    text:this.translate.instant('TRANSITION_MESSAGE2'),
                    showCloseButton: true,
                    confirmButtonText: this.translate.instant('ENTER')
                    }
                    if (hasKey && data.param.locked){
                      swalObj['footer']='<button id="lock-action'+time+'">'+this.translate.instant('DOOR_BEAN_5')+'</button>'
                    }
                    if (hasKey && !data.param.locked){
                      swalObj['footer']='<button id="lock-action'+time+'">'+this.translate.instant('DOOR_BEAN_4')+'</button>'
                    }
          
                  Swal.fire(swalObj).then((result) =>{
                    if (result.value) {         
                      if (data.param.teleport.constructor == Array){
                        let id= (Math.floor(Math.random() * data.param.teleport.length))  
                        this._appData.instagramUser.positionDoor={x:data.param.teleport[id].x,y:data.param.teleport[id].y,room:roomToGo,data,space:data.param.space}
                      }    
                      else if (data.param.teleport.x){
                        this._appData.instagramUser.positionDoor={x:data.param.teleport.x,y:data.param.teleport.y,z:data.param.teleport.z ? data.param.teleport.z : 0,room:roomToGo,space:data.param.space}

                      }
                      else{
                        this._appData.instagramUser.positionDoor={x:data.param.x,y:data.param.y,z:data.param.z ? data.param.z : 0,room:roomToGo,space:data.param.space}
                      }          
 
                      this._companyService.updateProfile(this._appData.instagramUser).then((res)=>{
                        this._appData.instagramUser.room=roomToGo;
                        let domain=window.location.origin
                        window.location.href = domain+"/gameevent/"+this._appData.event.id+"?room="+roomToGo;
                      }).catch(err=>{
                        if (err.message=='Missing or insufficient permissions.'){
                          $('#registerSocialModal').modal('show')
                          this._appData.tiping=true;
                        }
                      });
                    }
                  })
                  /*$(document).on('click', '#lock-action'+time, ()=> {
                    this.lock();
                  });*/ 
          
                }

              })  
          })


        } 
        else{
            let date=new Date()
            let time=date.getTime();
              let swalObj={
            title: this.translate.instant('DOOR_BEAN_0'),
            showCloseButton: true,
            text: this.translate.instant('DOOR_BEAN_6'),
            confirmButtonText: this.translate.instant('DOOR_BEAN_7'),
            showCancelButton: true,
            focusConfirm: false, 
            }
            if (data.hasKey){
              if (data.param.key && data.param.locked){
                swalObj['footer']='<button id="lock-action'+time+'">'+this.translate.instant('DOOR_BEAN_5')+'</button>'
              }
              if (data.param.key && !data.param.locked){
                swalObj['footer']='<button id="lock-action'+time+'">'+this.translate.instant('DOOR_BEAN_4')+'</button>'
              } 
            }         
            Swal.fire(swalObj).then((result) => {
              if (result.dismiss=='backdrop') {}
              else if (result.value) {
                let myX=this._appData.instagramUser.position.x
                let myY=this._appData.instagramUser.position.y


                let doorx=this.position.x;
                let doory=this.position.y;

                let doorOrient=(this.dimension.x>this.dimension.y);
                  //cima baixo
                  let xToGo;
                  let yToGo
                if (doorOrient){
                  if (myY>doory){
                    //tenho q ir pra o y menor
                    yToGo=data.param.yIn>data.param.yOut ? data.param.yOut : data.param.yIn
                    xToGo=data.param.yIn>data.param.yOut ? data.param.xOut : data.param.xIn
                  }
                  else{
                    //tenho q ir pra o y maior
                    yToGo=data.param.yIn<data.param.yOut ? data.param.yOut : data.param.yIn
                    xToGo=data.param.yIn<data.param.yOut ? data.param.xOut : data.param.xIn                    
                  }
                  this.sendIframeMessage({
                    kind:'updateUserStatus',
                    params:{uid:this._appData.instagramUser.uid,state:'stop',location:{x:xToGo,y:yToGo}}
                  });                       

                }
                else{
                  if (myX>doorx){
                    //tenho q ir pra o y menor
                    yToGo=data.param.xIn>data.param.xOut ? data.param.yOut : data.param.yIn
                    xToGo=data.param.xIn>data.param.xOut ? data.param.xOut : data.param.xIn
                  }
                  else{
                    //tenho q ir pra o y maior
                    yToGo=data.param.xIn<data.param.xOut ? data.param.yOut : data.param.yIn
                    xToGo=data.param.xIn<data.param.xOut ? data.param.xOut : data.param.xIn                    
                  }
                  this.sendIframeMessage({
                    kind:'updateUserStatus',
                    params:{uid:this._appData.instagramUser.uid,state:'stop',location:{x:xToGo,y:yToGo,space:this._appData.instagramUser.space}}
                  });                       
                }

              }
            })
/*            $(document).on('click', '#lock-action'+time, ()=> {
              this.lock();
            }); 
  */  
        }
    }
    public sendIframeMessage(messageKind){
		const event = new CustomEvent('angularMessage',{detail:messageKind});
		window.dispatchEvent(event);
      }
    public checkKey(needKey){
      if (needKey==this._appData.instagramUser.uid){
        return true;
      }
      else{
        let filtered=this._appData.userEventContainer.filter(val=>{
          if (val.param){
            if (val.param.door){
              return val.param.door==needKey                 
            }
            else if (val.param.room == needKey){
              return true;
            }
            else{
              return false;
            }
          }
          else{
            return false;
          }
        })
        if (filtered[0]){
          return true;
        } 
      }
      return false;
    }
    public bagUseItem(){
        Swal.fire({title:this.translate.instant('DOOR_BEAN_0'),
        text:this.translate.instant('DOOR_BEAN_9'),
        })

    }
    public useItem(){
        let title=this.translate.instant('DOOR_BEAN_0')
        let text=this.translate.instant('DOOR_BEAN_6')
        let cancel=this.translate.instant('NO')
        let configure=false;
        

        Swal.fire({title:title,
        text:text,
        confirmButtonText: this.translate.instant('DOOR_BEAN_14'),
        cancelButtonText:cancel,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false, 
        }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){
            if (configure){
              Swal.fire({title:this.translate.instant('DOOR_BEAN_13'),
              text:this.translate.instant('DOOR_BEAN_15'),
              confirmButtonText: this.translate.instant('DOOR_BEAN_16'),
              cancelButtonText:this.translate.instant('DOOR_BEAN_17'),
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false, 
              }).then((result) => {
                if (result.dismiss=='backdrop') {}
                else if (result.dismiss=='close') {}
                else if (result.dismiss=='cancel'){//mesma sala
                  Swal.fire({title:this.translate.instant('DOOR_BEAN_18'),
                    text:this.translate.instant('DOOR_BEAN_19'),
                    confirmButtonText: this.translate.instant('YES'),
                    cancelButtonText:this.translate.instant('NO'),
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false, 
                    }).then((result) => {
                    if (result.dismiss=='backdrop') {}
                    else if (result.dismiss=='close') {}
                    else if (result.dismiss=='cancel'){//nao
                      Swal.fire({title:this.translate.instant('DOOR_BEAN_20'),text:this.translate.instant('DOOR_BEAN_21')})
                    }
                    else{
                      let sin=this.dimension.x>this.dimension.y;
                      this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.objectId.toString()).set(this.toDB()).then(v=>{
                        Swal.fire({title:this.translate.instant('DOOR_BEAN_30'),text:this.translate.instant('DOOR_BEAN_31')})
                      })
                    }
                  });
                }
                else{//outra sala
                  this._companyService.getRooms().where('father','==',this._appData.room.id).get().then(v=>{
                    let rooms={}
                    let fullRooms={}
                    rooms[this._appData.room.father]=this.translate.instant('DOOR_BEAN_32')
                    fullRooms[this._appData.room.father]={id:this._appData.room.father,name:this.translate.instant('DOOR_BEAN_32'),defaultPlace:this._appData.room.fatherLocation}
                    v.forEach(r=>{
                      let room=r.data()
                      rooms[room.id]=room.roomName
                      fullRooms[room.id]=room;
                    })
                    Swal.fire({
                      title: this.translate.instant('DOOR_BEAN_33'),
                      input: 'select',
                      inputOptions: rooms,
                      inputPlaceholder: this.translate.instant('DOOR_BEAN_34'),
                      showCancelButton: true,
                    }).then( (result) =>{
                      this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.objectId.toString()).set(this.toDB()).then(v=>{
                        Swal.fire({title:this.translate.instant('DOOR_BEAN_30'),text:this.translate.instant('DOOR_BEAN_31')})
                      })
                    })  
                  })

                }
              });
            }
          }

        });
    }
};




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/itens/door.bean.ts